import { render, staticRenderFns } from "./SearchAutocomplete.vue?vue&type=template&id=a28d3fd6&"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports